import { clickTab, arrowClick } from './tabs';
import { expandTable, expandDetails } from './tables';

/**
 * Bind DOM Events
 */
export default function bindEvents() {
  $('.expand-table').on('click', expandTable);
  $('.table-default-skin .table-row').on('click', expandDetails);
  $('.single-tab').on('click', clickTab);
  // $('.social-icons-icon').on('click', function clickSocial() {
  //    const socialSite = $(this).attr('data-social');
  //    ga('send', 'event', 'compartilhamento', socialSite, window.location.href);
  // });
  $('.arrow-left, .arrow-right').on('click', arrowClick);
  let triggerAnalyticsOnce = true;
  $(window).on('scroll', () => {
    const spaceBeforeSectionCircuits = 300;
    const sectionCircuitTop = $('.section-circuits').offset().top - spaceBeforeSectionCircuits;
    if ($(window).scrollTop() > sectionCircuitTop && triggerAnalyticsOnce) {
      // if (ga) {
      //   const year = $('.container-f1').attr('data-year');
      //   const $activeCircuit = $('.single-tab.active-circuit');
      //   const activeCircuitName = $activeCircuit.attr('data-circuit-name');
      //   ga('send', 'event', `formula 1 ${year}`, activeCircuitName, 'circuito exibido');
      // }
      triggerAnalyticsOnce = false;
    }
  });
}



// WEBPACK FOOTER //
// local_static/templates/motor/2017/assets/scripts/events.js